import { CardMedia } from '@mui/material';
import { GlobalImageData } from '../../models/app-data-model';
import { getContentHubDamAsset } from '../../utils/get-contenthub-dam-asset';
import './GlobalImage.scss';

import React from 'react';

export type GlobalImageProps = {
  globalImageData?: GlobalImageData;
};

const GlobalImage: React.FC<GlobalImageProps> = ({ globalImageData }) => {
  const image = globalImageData && getContentHubDamAsset(globalImageData?.contenthub_asset, globalImageData?.manual_overwrites);

  return <img
    src={ image?.url }
    alt={ image?.alt_text }
    title={ image?.title}
    loading="lazy"
  />;
};

export default GlobalImage;
